import { ENV } from '@/constants'

/**
 * Get backend endpoint function.
 */

export function getBaseAPI () {
  switch (ENV) {
    case 'development':
      return 'http://localhost:3000'
    case 'develop':
      return 'https://kulaperdev-api.kulap.io/v1/api'
    case 'alpha':
      return 'https://alpha-api.kulap.io/v1/api'
    case 'insider':
      return 'https://api.kulap.io/v1/api'
    case 'swap':
      return 'https://api.kulap.io/v1/api'
    default:
      return 'https://api.kulap.io/v1/api'
  }
}

export function getBaseURL () {
  switch (ENV) {
    case 'development':
      return 'http://localhost:8080'
    case 'develop':
      return 'https://kulaperdev.kulap.io'
    case 'alpha':
      return 'https://alpha.kulap.io'
    case 'insider':
      return 'https://swap.kulap.io'
    case 'swap':
      return 'https://swap.kulap.io'
    default:
      return 'https://swap.kulap.io'
  }
}

export function getKulapPlusURL () {
  switch (ENV) {
    case 'development':
      return 'https://buy-dev.kulap.io'
    case 'develop':
      return 'https://buy-dev.kulap.io'
    case 'alpha':
      return 'https://buy-dev.kulap.io'
    case 'insider':
      return 'https://buy-beta.kulap.io'
    case 'swap':
      return 'https://buy.kulap.io'
    default:
      return 'https://buy.kulap.io'
  }
}

export function getCorrectNetwork () {
  switch (ENV) {
    case 'development':
      return process.env.ETH_NETWORK || 'main'
    case 'develop':
      return 'main'
    case 'alpha':
      return 'main'
    case 'insider':
      return 'main'
    case 'swap':
      return 'main'
    default:
      return 'main'
  }
}

export function isCorrectNetwork (currentNetwork) {
  switch (ENV) {
    case 'development': {
      if (process.env.ETH_NETWORK === 'kovan') {
        return currentNetwork === 'kovan'
      }
      return currentNetwork === 'main'
    }
    case 'develop':
      return currentNetwork === 'kovan'
    case 'alpha':
      return currentNetwork === 'main'
    case 'insider':
      return currentNetwork === 'main'
    case 'swap':
      return currentNetwork === 'main'
    default:
      return currentNetwork === 'main'
  }
}

export function getEterScanUrl (currentNetwork) {
  switch (currentNetwork) {
    case 'ropsten':
      return 'https://ropsten.etherscan.io'
    case 'kovan':
      return 'https://kovan.etherscan.io'
    case 'main':
      return 'https://etherscan.io'
    default:
      return 'https://etherscan.io'
  }
}

export function getFacebookAppId () {
  switch (ENV) {
    case 'development':
      return '758969598011446'
    case 'develop':
      return '423194548550858'
    case 'alpha':
      return '2228084830653503'
    case 'insider':
      return '370828216898781' // '2186065634830686'
    case 'swap':
      return '370828216898781'
    default:
      return '370828216898781'
  }
}

export function getAmplitudeKey () {
  switch (ENV) {
    case 'development':
      return '19b47c3825f3795778ab961ae79ac71d'
    case 'develop':
      return '19b47c3825f3795778ab961ae79ac71d'
    case 'alpha':
      return 'e592f413b55c235110a04a44ba0e5e07'
    case 'swap':
      return '3542f856adc1ed90c5ab6a7d7bc982c8'
    default:
      return '19b47c3825f3795778ab961ae79ac71d'
  }
}

export function getS3BucketKulapUtilityFileUrl () {
  switch (ENV) {
    case 'development':
      return 'https://kulap-utility-file.s3-ap-southeast-1.amazonaws.com'
    case 'develop':
      return 'https://kulap-utility-file-develop.s3-ap-southeast-1.amazonaws.com'
    case 'alpha':
      return 'https://kulap-utility-file-alpha.s3-ap-southeast-1.amazonaws.com'
    case 'swap':
      return 'https://kulap-utility-file.s3-ap-southeast-1.amazonaws.com'
    default:
      return 'https://kulap-utility-file.s3-ap-southeast-1.amazonaws.com'
  }
}

export const getTheCorrectNetwork = () => {
  switch (process.env.VUE_APP_ENV) {
    case 'development':
      return 'kovan'
    case 'develop':
      return 'kovan'
    case 'alpha':
      return 'main'
    case 'swap':
      return 'main'
    default:
      return 'main'
  }
}



// WEBPACK FOOTER //
// ./src/environments/index.js